"use client";
import { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { AiOutlineClockCircle, AiOutlineClose } from "react-icons/ai";
import styles from "./verifyPhone.module.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";
import OTPInput from "./indexOTP";
import { useUser } from "@hooks/Auth/useUser";
import { getRecaptchaInfo, sendOtp, verifyOtp } from "@services/authAPI";
import { Skeleton } from "@mui/material";
import { FaEdit } from "react-icons/fa";
import Cookies from "js-cookie";
const VerifyPhoneDialog = ({ phoneNumber, closeVerification, event }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [close, setClose] = useState(false);
  console.log(event.settings["phone-verification-sms"]);
  const [otpValue, setOtpValue] = useState("");

  const [error, setError] = useState("");
  const [errorSend, setErrorSend] = useState("");
  const [errorPhone, setErrorPhone] = useState(false);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [timer, setTimer] = useState(5);
  const [capVal, setCapVal] = useState(null);
  const [sToken, setSToken] = useState(null);
  const [sTokenLoading, setSTokenLoading] = useState(false);
  const [errorCaptcha, setErrorCaptcha] = useState(false);
  const { user } = useUser();
  const [phone, setPhone] = useState(user.phoneNumber);
  const [pathType, setPathType] = useState("whatsapp");
  useEffect(() => {
    const pathChange = () => {
      if (!event.settings["phone-verification-whatsapp"]) setPathType("sms");
    };

    pathChange();
  }, [user, phone]);
  const [timeRemaining, setTimeRemaining] = useState(3 * 60 * 1000);
  // console.log(user.phoneNumber);
  useEffect(() => {
    setPhone(user.phoneNumber);
  }, [user]);
  const closeModal = (e) => {
    setClose(false);
  };
  useEffect(() => {
    handleSToken();
  }, []);
  const handleSToken = async () => {
    setSTokenLoading(true);
    setSToken(null);
    try {
      const response = await getRecaptchaInfo();
      // console.log(response.data.data.recaptchaStoken);
      setSToken(response.data.data.recaptchaStoken);
    } catch (error) {
      // console.log(error);
    }
    setSTokenLoading(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side validation
    if (!isValidPhoneNumber(phone)) {
      setErrorPhone(true);
      return;
    } else {
      setErrorPhone(false);
    }

    if (!capVal) {
      setErrorCaptcha(true);
      return;
    } else {
      setErrorCaptcha(false);
    }

    // If both phone number and reCAPTCHA are valid, proceed with form submission
    setIsLoading(true);
    // // console.log(capVal);
    try {
      const response = await sendOtp(
        phone,
        capVal,
        user.id,
        pathType,
        "tickit.co"
      );
      // console.log(response.data.data.sessionInfo);
      setSessionInfo(response.data.data.sessionInfo);
      console.log(response.data.data.resendTime);
      setTimeRemaining(response.data.data.resendTime * 60 * 1000);
      setShowOtp(true);
      setIsLoading(false);
    } catch (e) {
      const message = e.response.data.message;
      console.log(message);
      setErrorSend(message.replace(/_/g, " "));
      // closeVerification();
      setIsLoading(false);
    }
    // Perform additional actions like API calls or form submission here

    setIsLoading(false);
  };
  const handleSubmitOtp = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let val = otpValue;

    try {
      const response = await verifyOtp(
        sessionInfo,
        val,
        user.idToken.replace(/\s/g, ""),
        user.id,
        phone,
        "tickit.co"
      );
      // console.log(response);
      if (response.status === 200) {
        // Assuming response.data.data is an object with a uid property
        const originalData = user;
        console.log(response.data.data.user.phoneNumber);
        // Create a new object with the changes
        const modifiedData = {
          ...originalData,
          isPhoneVerified: true,
          phoneNumber: response.data.data.user.phoneNumber,
        };

        // Store the modified object in cookies
        Cookies.set("user", JSON.stringify(modifiedData));
        console.log(modifiedData);
        closeVerification(phone);
      }
    } catch (error) {
      // console.log(error);
      setError(error.response.data.message);

      setIsLoading(false);
    }
    setIsLoading(false);
  };
  // timer

  const formatTime = (timeInMilliseconds) => {
    const totalSeconds = Math.floor(timeInMilliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };
  const [disableBtn, setDisableBtn] = useState(true);
  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeRemaining((prevTime) => (prevTime > 1000 ? prevTime - 1000 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  useEffect(() => {
    if (timeRemaining === 0) {
      setDisableBtn(false);
    }
  }, [timeRemaining]);

  return (
    <div className={styles.overlay}>
      <div className={`${styles.modal} ${false ? styles.fadeOut : ""}`}>
        <div as="h3" className={styles.title}>
          <span>{"Verify Phone Number"}</span>
        </div>
        <div as="div" className={styles.body}>
          <div style={{ width: "100%" }}>
            {!showOtp ? (
              <form action="" onSubmit={handleSubmit}>
                {phoneNumber && (
                  <div className={styles.phone_input}>
                    <PhoneInput
                      country={"us"}
                      value={phone}
                      onChange={(e) => {
                        // console.log(e);
                        setPhone(e);
                      }}
                      placeholder={"Your Phone Number"}
                    />
                  </div>
                )}
                <div className={styles.pathType}>
                  <label>
                    <input
                      type="checkbox"
                      checked={pathType === "sms"}
                      onChange={(e) => {
                        setPathType("sms");
                      }}
                      disabled={!event.settings["phone-verification-sms"]}
                    />
                    &nbsp; SMS
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      checked={pathType === "whatsapp"}
                      onChange={(e) => {
                        setPathType("whatsapp");
                      }}
                      disabled={!event.settings["phone-verification-whatsapp"]}
                    />
                    &nbsp; WHATSAPP
                  </label>
                </div>
                {sToken ? (
                  <ReCAPTCHA
                    sitekey="6LcMZR0UAAAAALgPMcgHwga7gY5p8QMg1Hj-bmUv"
                    onChange={(val) => {
                      // console.log(val);
                      setCapVal(val);
                      if (val === null) handleSToken();
                    }}
                    stoken={sToken}
                    theme="dark"
                    size="normal"
                  />
                ) : (
                  <Skeleton animation="wave" height={100} />
                )}
                {errorCaptcha && (
                  <p style={{ color: "red", fontSize: "12px" }}>
                    Please Check the reCAPTCHA
                  </p>
                )}
                {errorPhone && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      position: "relative",
                      margin: "5px 0px",
                    }}
                  >
                    Please Enter A Valid Phone Number
                  </p>
                )}
                {errorSend !== "" && (
                  <p
                    style={{
                      color: "red",
                      fontSize: "12px",
                      position: "relative",
                      margin: "5px 0px",
                    }}
                  >
                    {errorSend}
                  </p>
                )}

                <div className={styles.btn_wrap}>
                  <button
                    disabled={isLoading || sTokenLoading || !capVal}
                    className={
                      (isLoading || sTokenLoading || !capVal) &&
                      styles.disabledBtn
                    }
                    type="submit"
                  >
                    {isLoading ? "Loading.." : "Next"}
                  </button>
                </div>
              </form>
            ) : (
              <form onSubmit={handleSubmitOtp}>
                <p className={styles.note}>
                  We have sent an SMS containing the OTP number to the provided
                  phone number: <span>{phone}</span> &nbsp;{" "}
                  <FaEdit
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowOtp(false)}
                  />
                </p>
                <OTPInput
                  autoFocus
                  isNumberInput
                  length={6}
                  className="otpContainer"
                  separatorType={"-"}
                  itemsPerSeparator={3}
                  inputClassName="otpInput"
                  onChangeOTP={(otp) => {
                    setOtpValue(otp);
                    console.log(otp);
                  }}
                />
                <p className={styles.resendCode}>{error !== "" && error}</p>
                <div
                  className={styles.clock}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* you can resend code after &nbsp; */}
                  <span>{formatTime(timeRemaining)}, </span>
                  <button
                    disabled={disableBtn}
                    style={disableBtn ? { color: `gray` } : { color: "white" }}
                    onClick={(e) => {
                      handleSubmit(e);
                      setTimeRemaining(timer * 60 * 1000);
                      setDisableBtn(true);
                    }}
                  >
                    Resend Code?
                  </button>
                </div>

                <div className={styles.btn_wrap}>
                  <button
                    disabled={otpValue.length !== 6}
                    className={otpValue.length !== 6 && styles.disabledBtn}
                    type="submit"
                  >
                    {isLoading ? "Loading.." : "Submit"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyPhoneDialog;
